import React, { useState, useEffect } from 'react'
import { CountHitChart } from './CountHitChart'
import { Services } from '@/services/services'
import { CurrentSession } from '@/services/repository/session'
import { useTranslations } from '@/hooks/useTranslations'
import { SearchCriteria, SearchCriteriaParams } from '@/pages/communal/statistics/components/common/searchCriteria'
import { mapBuckets } from '../common/labels'
import { HelpPopupBody, HelpPopupButton, openHelpPopup } from '@/popups/helppopup/help'
import { useModal } from '@/components/modal/Modal'

type CountHitBoxProps = {
  services: Services
  session: CurrentSession
  criteria: SearchCriteria
}

// Interface representing a single bucket entry
export interface CountHitBucket {
  bucket: string     // ISO timestamp string
  countHits: number  // Countimum hit value
}

// Interface representing the full API response
export type HitDataResponse = {
  buckets: CountHitBucket[]
  forTime: string
}

export const CountHitBox = ({ services, session, criteria }: CountHitBoxProps) => {
  const translates = useTranslations(services, session)
  const [response, setResponse] = useState<HitDataResponse>()

  useEffect(() => {
    setResponse(undefined)
    services.session
      .fetchWithToken(`/api/communal/statistics/machines/hitcount?${SearchCriteriaParams(criteria)}`)
      .then((r) => r.json())
      .then((data) => {
        setResponse(data)
      })
  }, [services.session, criteria])

  if (translates === undefined || !response) {
    return <div className='spinner'></div>
  }

  const labels = response.buckets.map(mapBuckets)
  const dataSet = response.buckets.map(bucket => bucket.countHits)

  return (
    <div>
      <HelpPopupButton helpKey='page.dashboard.global.box.counthits.help' translates={translates}/>
      <CountHitChart labels={labels} dataSet={dataSet}
        chartTitle={translates.for('page.dashboard.global.box.counthits.title')}
        dataLabel={translates.for('page.dashboard.global.box.counthits.data_label')} />
    </div>
  )
}